import { render } from "./ProfileOverview.vue?vue&type=template&id=e4d92b5a&ts=true"
import script from "./ProfileOverview.vue?vue&type=script&lang=ts"
export * from "./ProfileOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__